var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsdtCircle = function SvgUsdtCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usdt-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009393",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.857 6.75v2.127H13.46v1.475c3.088.157 5.405.805 5.422 1.58v1.618c-.017.776-2.334 1.423-5.422 1.58v3.62h-2.92v-3.62c-3.088-.157-5.405-.804-5.422-1.58v-1.617c.017-.776 2.334-1.424 5.422-1.581V8.877H6.143V6.75zM12 14.02c3.296 0 6.05-.548 6.725-1.279-.572-.62-2.64-1.107-5.265-1.241v1.544a29 29 0 0 1-2.92 0V11.5c-2.625.134-4.693.621-5.265 1.241.675.731 3.43 1.279 6.725 1.279",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "usdt-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
  })))));
};
export { SvgUsdtCircle as ReactComponent };